<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex mb-4 xs12>
          <h1>Manage Wristband</h1>
          Someday... you will be able to check your wristband credit/usage
      </v-flex>
      <v-flex mb-4 xs12 text-xs-center>
          <div class='event_profile_code' my-4>
              Got It ^^
          </div>
      </v-flex>
      <v-flex mt-4 xs12>
	    <v-btn :to="`/events/${event.id}`">OK</v-btn>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';

export default {
  data: () => ({event: {}, link_code: '--'}),
  beforeMount: async function() {
    await this.$store.dispatch('loadEvents');
    await this.$store.dispatch('loadAttendees');
    this.show_event();
    this.determine_link_code();
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees']),
  },
  watch: {
    events(to, from) {
      this.show_event();
    },
    attendees(to, from) {
      this.determine_link_code();
    },
  },
  methods: {
    show_event() {
      this.$data.event = this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
    determine_link_code() {
      let at = this.attendees?.find(x => {
        return x.event_id == this.$route.params.event_id;
      });
      this.$data.link_code = at?.link_code;
    },
  },
};
</script>

<style>
.event_profile_code {
  font-size: 3em;
  padding: 1em;
  border: 0px solid black;
}
</style>
